import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { buildInviteText, sendWhatsApp } from "@/lib/whatsapp";

export const InviteModal = ({ onClose, initialName = "", initialPhone = "" }) => {
  const [phone, setPhone] = useState(initialPhone);
  const [text, setText] = useState(buildInviteText(initialName));
  return <div className="modal-backdrop"><div className="modal invite-modal" data-testid="invite-modal">
    <button data-testid="invite-modal-close-button" className="icon-btn close" onClick={onClose}><X /></button>
    <p className="eyebrow">CONVITE · WHATSAPP</p><h2>Seja um Contribuinte</h2>
    <div className="invite-grid">
      <img data-testid="invite-banner" className="invite-banner" src="/banner-contribuinte.jpg" alt="Banner Seja um Contribuinte" />
      <div className="invite-form">
        <label>WhatsApp (opcional)<input data-testid="invite-phone-input" value={phone} onChange={e => setPhone(e.target.value)} placeholder="(11) 90000-0000" /></label>
        <label>Mensagem<textarea data-testid="invite-message-input" value={text} onChange={e => setText(e.target.value)} rows={12} /></label>
        <button data-testid="invite-send-button" className="whatsapp-btn" onClick={() => sendWhatsApp({ phone, text })}><MessageCircle size={17} /> Enviar no WhatsApp</button>
        <small className="muted">No celular o banner vai anexado. No computador, o link do banner segue junto com a mensagem.</small>
      </div>
    </div>
  </div></div>;
};
